// Пустая расшифровка приходила обычным успехом: статус «готово», ноль знаков и
// никакого объяснения. 07.08.2026 пользователь так загрузил один файл 32 раза
// подряд — отличить «в файле нет речи» от «мы не смогли» было нельзя.
//
// Два признака, потому что источников два. `bit-transcribe-v3` шлёт явный
// `no_speech` в статусе задачи; остальные движки (диаризация, parakeet,
// стерео-АТС) такого поля не знают, и там единственный признак — пустой
// результат. Второй заодно страхует первый, пока новый образ v3 не выкачен.

export const NO_SPEECH_MESSAGE =
  'Речь не распознана: в файле не нашлось речи. Проверьте, что запись со звуком '
  + 'и что голос слышен — например, откройте её плеером.';

/** Речи нет по ответу `/get_status` — сервис сказал об этом сам. */
export function statusHasNoSpeech(data) {
  return data?.no_speech === true;
}

/** Речи нет по результату: пустой текст или фрагменты без единого слова. */
export function resultIsEmpty(result) {
  if (Array.isArray(result)) {
    return !result.some((fragment) => String(fragment?.text || '').trim());
  }
  return !String(result || '').trim();
}
